export default __webpack_public_path__ + "static/media/sept-regles-psychomotricite.924fc535.jpg";